// extracted by mini-css-extract-plugin
export default {"uploadFiles":"form-new-project_uploadFiles__1OIE6"};